import React from "react";

interface LoadingScreenProps {
    message?: string;
}

export default function LoadingScreen({ message = "Loading..." }: LoadingScreenProps) {
    return (
        <div id="content" className="bg-white">
            <div
                id="root-loading-screen"
                style={{
                    background: "white",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    zIndex: 60
                }}
            >
                <img
                    src="/images/logo.png"
                    alt="Roboflow Logo"
                    style={{
                        display: "block",
                        width: "200px",
                        height: "auto",
                        margin: "20px auto"
                    }}
                />
                <img
                    src="/images/running_lenny_outline_128w.gif"
                    alt="Roboflow Running Logo"
                    style={{ width: "70px", height: "auto" }}
                    className="py-4"
                />

                <div className="animated my-2 animate-pulse font-mono text-sm font-normal text-gray-500">
                    {message}
                </div>
            </div>
        </div>
    );
}
